import { Tag } from '~/components/tag'
import type { TagVariants } from '~/components/tag/types'
import { useInputPasswordProps } from '../../hooks'
import type { InputPasswordTagProps } from '../../types'
import { Container } from './input-password-tag.styles'

export const InputPasswordTag = ({
  active = false,
  variant,
  testID,
}: InputPasswordTagProps) => {
  const { isFilled, disabled, readonly } = useInputPasswordProps()

  const renderTagVariant = (): TagVariants => {
    switch (variant) {
      case 'AVERAGE':
        return 'average'
      case 'STRONG':
        return 'strong'
      default:
        return 'weak'
    }
  }

  const renderTagLabel = (): 'Forte' | 'Fraca' | 'Média' => {
    switch (variant) {
      case 'AVERAGE':
        return 'Média'
      case 'STRONG':
        return 'Forte'
      default:
        return 'Fraca'
    }
  }

  if (!isFilled || !active || disabled || readonly) return null

  return (
    <Container>
      <Tag.Root variant={renderTagVariant()} testID={testID}>
        <Tag.Label>{renderTagLabel()}</Tag.Label>
      </Tag.Root>
    </Container>
  )
}
